<style lang='stylus'scoped>
active = #336db0;

.title {
  font-size: 18px;
  color: #999999;
  position: relative;

  &:first-child {
    margin-right: 40px;
  }

  &::after {
    content: '';
    display: block;
    height: 3px;
    position: absolute;
    bottom: -12px;
    left: 15%;
    width: 70%;
  }
}

.title.active {
  color: active;

  &::after {
    background: @color;
  }
}

.demonstration {
  color: #999;
  font-size: 18px;
  margin-right: 15px;
}

.header {
  display: flex;
  justify-content: space-between;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.carWrap {
  // display: flex;
  // flex-direction: column;
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
    display: flex;

    .table {
      flex: 1;
    }
  }
}

.block {
  // width: fit-content;
  // margin-left: auto;
  // margin-right: auto;
  display: flex;

  .center {
    margin: 10px auto;
  }
}
</style>

<template>
  <div class="carWrap" style="height:100%;">
    <exportDate
      v-if="showExport"
      @hideExport="hideExport1"
      :toExportDetail="toExportDetail"
      :moduleName="moduleName"
      :roadCode="roadCode"
    />
    <div class="header">
      <TitleHeader :titleArr="titleArr" :changeTab="changeTab" :tab="tab"/>
      <div class="righth">
        <span class="demonstration">统计月份</span>
        <el-date-picker
          v-model="defaultTime"
          type="month"
          placeholder="选择月"
          @change="changeTime"
          value-format="yyyy-MM"
        ></el-date-picker>
        <el-button style="margin-left:15px;" @click="goBack">返回上级</el-button>
        <el-button v-show="hideExport" style="margin-left:15px;" @click="exportDate">导出</el-button>
      </div>
    </div>
    <main>
      <div class="table">
        <StopTable :allData="allData" v-if="tab == 0"></StopTable>
        <TimeTable :allData="allData" v-else></TimeTable>
      </div>
    </main>
  </div>
</template>
<script>
/**
 * @file:  View view
 * @author: v_chengmengya
 * @date: 2019-05-16
 * @description: 高速公路运营统计详情
 */
import StopTable from './components/stopTable' // 高速加油站停靠表格
import TimeTable from './components/timeTable' // 高速运营时段表格
import TitleHeader from '../carOperate1/components/titleHeader' // 复用父组件tab切换
import Cookies from 'js-cookie'
import http from '@/api/freight.js' //请求汇总
import Util from '@/utils/util'
import { hideExport } from '@/utils/tools'
export default {
  components: {
    StopTable,
    TimeTable,
    TitleHeader
  },
  data() {
    return {
      hideExport:hideExport,
      titleArr: ['高速加油站停靠统计', '高速运营时段统计'],
      tab: 0, // 0 ->高速加油站 1 ->高速运营时段
      allData: [], // 总数据
      index: 1, // 当前页数
      defaultTime: '', //请求日期
      roadCode: '', //公路代码
      moduleName: 'motorOperatorVehicleCount', //
      showExport: false //控制批量导出
    }
  },
  created() {
    let that = this
    let tab = this.$route.query.type // 获取上级的tab切换
    this.tab = tab ? tab : 0
    let defaultTime = this.$route.query.endMonth
      ? this.$route.query.endMonth.substr(0, 4) +
        '-' +
        this.$route.query.endMonth.substr(4, 6)
      : Util.lastTime(new Date() * 1)
    this.defaultTime = defaultTime //获取上级时间
    let roadCode = this.$route.query.roadCode
    that.roadCode = roadCode
  },
  mounted() {
    this.initData() // 无参代表首次请求
  },
  methods: {
    goBack() {
      this.$router.push({
        name: 'carOperate1',
        query: {
          type: this.tab
        }
      })
    },
    initData() {
      let that = this
      http
        .carOpeDetail({
          year: that.defaultTime.split('-')[0],
          roadCode: that.roadCode,
          month: that.defaultTime.split('-')[1],
          type: that.tab
        })
        .then(e => {
          if (e.code == 200 && e.data) {
            that.allData = [...e.data]
          } else {
            that.allData = []
          }
        })
    },
    changeTab(index) {
      let that = this
      that.tab = index
      this.initData()
    },
    changeTime() {
      let that = this
      that.initData()
    },
    exportDate() {
      this.showExport = true
      return
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    toExportDetail(yearMonths, reqId) {
      let that = this
      let type = that.tab
      let roadCode = that.roadCode
      window.location.assign(
        http.carOpeDetailExport({
          yearMonths,
          reqId,
          type,
          roadCode
        })
      )
    }
  }
}
</script>